import React from 'react';
import styled from 'styled-components';
import {
  minBreakpointQuery,
  sectionMargins,
  brandColours,
  maxBreakpointQuery,
} from '../styles';
import { Container, Heading } from './ui';

const StyledInfoTable = styled.section`
  ${sectionMargins()};
`;

const StyledHeading = styled(Heading)`
  margin-bottom: 20px;

  ${minBreakpointQuery.small`
    margin-bottom: 25px;
  `}

  ${minBreakpointQuery.large`
    margin-bottom: 30px;
  `}
`;

const StyledOuter = styled.div`
  ${minBreakpointQuery.large`
    position: relative;
  `}

  &:before {
    ${minBreakpointQuery.large`
      content: '';
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 50%;
      background-color: ${({ altTheme }) =>
        altTheme ? brandColours.primary : brandColours.senary};
    `}
  }
`;

const StyledInner = styled.div`
  padding: 20px 0;
  background-color: ${({ altTheme }) =>
    altTheme ? brandColours.primary : brandColours.senary};

  ${maxBreakpointQuery.large`
    margin-right: -20px;
    margin-left: -20px;
  `}

  ${minBreakpointQuery.small`
    padding-top: 30px;
    padding-bottom: 30px;
  `}

  ${minBreakpointQuery.large`
    position: relative;
    padding-top: 40px;
    padding-bottom: 40px;
  `}
`;

const StyledTable = styled.table`
  width: 100%;
`;

const StyledBody = styled.tbody``;

const StyledRow = styled.tr``;

const StyledHeader = styled.th`
  padding: 10px 10px 10px 0;
  width: 40%;
  font-weight: inherit;
  text-align: left;
`;

const StyledData = styled.td`
  padding: 10px 0;
  width: 60%;
`;

const InfoTable = ({ heading, rows, altTheme }) =>
  rows &&
  rows.length > 0 && (
    <StyledInfoTable>
      <Container narrow={true}>
        <StyledHeading>{heading}</StyledHeading>
      </Container>
      <StyledOuter altTheme={altTheme}>
        <Container>
          <StyledInner altTheme={altTheme}>
            <Container narrow={true}>
              <StyledTable>
                <StyledBody>
                  {rows.map(({ name, value }, i) => (
                    <StyledRow key={`info-table-row-${i}`}>
                      <StyledHeader>{name}</StyledHeader>
                      <StyledData>{value}</StyledData>
                    </StyledRow>
                  ))}
                </StyledBody>
              </StyledTable>
            </Container>
          </StyledInner>
        </Container>
      </StyledOuter>
    </StyledInfoTable>
  );

export default InfoTable;
